import React from 'react'
import {
    useSearchParams
    // , Link 
} from 'react-router-dom';


// ... 导入其他你需要的插件

function Aprodtsy() {
    const HNTOKENKEY='hntoken_key'
    const tk=localStorage.getItem(HNTOKENKEY)

    const [urlp] = useSearchParams()
  




    return (
        <>


            <div style={{ border: '1px solid #ccc', marginTop: '10px', zIndex: 100 }}>
        
            <iframe
      src={`http://www.ddspp.com/nyimg/?pno=`+urlp.get("q")+`&t=`+tk}
      width="100%"
      height="600"
      title="示例嵌入页面" // 为无障碍访问提供描述性标题很重要[3,5](@ref)
      style={{ border: 'none' }}
    />
            </div>

        </>
    )
}

export default Aprodtsy